import View from './C3.vue'
import * as controls from './Controls'

export default {
  View,
  controls,
}
